import { render, staticRenderFns } from "./BookingPolicyPreview.vue?vue&type=template&id=6dc0bb5e&"
import script from "./BookingPolicyPreview.vue?vue&type=script&lang=js&"
export * from "./BookingPolicyPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports